export const APP_FILE_PROJECTS = "/projects";
export const APP_FILE_MANAGE_PROJECTS = "/projects/manage-project";
